import { render } from "./MediaPage.vue?vue&type=template&id=97b030ea&scoped=true"
import script from "./MediaPage.vue?vue&type=script&lang=js"
export * from "./MediaPage.vue?vue&type=script&lang=js"

import "./MediaPage.vue?vue&type=style&index=0&id=97b030ea&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97b030ea"]])

export default __exports__